
import { reactive, computed, onMounted, watch } from 'vue';
import Checkbox from '../checkbox/index.vue';
import { useI18n } from 'vue-i18n';
export default {
  components: {
    Checkbox
  },
  props: {
    placeholder: {  // placeholder
      type: Object,
      default() {
        return {
          text: 'Select Please',
          val: 'default',
        }
      }
    },
    options: {
      type: Array,
      default() {
        return [
          {
            text: '1-001',
            val: '001',
          },
          {
            text: '1-002',
            val: '002',
          },
          {
            text: '1-003',
            val: '003',
          },
          {
            text: '在這一連串資料下取得 value 之特性屬性的陣列',
            val: '004',
          },
          {
            text: '一個陣列包含了一串物件',
            val: '005',
          },
          {
            text: '取得特性屬性值的陣列',
            val: '006',
          },
        ]
      }
    },
    selected: {   //被選擇的值
      type: Array,
      default() {
        return [
          {
            text: '1-003',
            val: '003',
          },
        ]
      }
    }, //end: selected
    isError: {
      type: Boolean,
      default: false,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    h: {
      type: String,
      default: 'default', // xl -> 56px
    },
    error: {
      type: String,
      default: '',
      require: false,
    },
    isShowErrorTxt: {   //當有錯誤時是否顯示錯誤文字
      type: Boolean,
      default: true,
    },
    listWidth: {   //option list width
      type: String,
      default: '',
    },
    hasAll: {   //有無全選項目
      type: String,
      default: 'All',
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const { selected, isDisable } = props;
    //data
    let state = reactive({
      all: false,
      // dataCheck: [],
      isOpen: false,
      errorStyle: '',
      disableStyle: isDisable ? 'style--disable' : '',
    })
    //computed
    const classStyle = computed(() => {
      return [
        { 'active': state.isOpen },
        { 'style--error': props.isError },
        { 'style--error': props.error },
        { 'style--disable': props.isDisable },
        'style--' + props.h,
      ]
    })
    let privateSelected = computed({
      get() {
        return selected;
      },
      set: (val) => {
        // console.log(val)
        emit('update:selected', val);
      }
    })


    onMounted(() => {
      dataInit()
    })

    const dataInit = () => { //如果要用CheckBox 組建的話要有一組勾選與否的序列
      state.all = props.selected.length == props.options.length ? true : false;
      // state.dataCheck = new Array(props.options.length).fill(false)
    }


    //change selected option, methods
    const onChange = (item) => {

      let temp = [...props.selected]
      let flag = false;

      for (let i = 0; i < temp.length; i++) {
        if (temp[i].val == item.val) {
          // console.log(temp[i].val , item.val)
          temp.splice(i, 1)
          flag = true;
        }
      }
      if (!flag) temp.push(item)


      privateSelected.value = temp;
      emit('onChange', temp);
    }




    const selectAll = () => {
      state.all = !state.all
      let temp = []
      if (state.all) {
        temp = [...props.options]
      } else {
        temp = []
      }
      privateSelected.value = temp;
      emit('onChange', temp);
    }



    watch(
      () => props.selected,
      (val) => {
        state.all = val.length == props.options.length ? true : false;
      },
      { deep: true }
    )


    const checkStyle = (item) => {
      let flag = false;
      if (props.selected.length) {
        props.selected.forEach(e => {
          if (e.val == item.val) {
            flag = true
          }
        });
      }
      return flag
    }

    const textLimit = computed(
      () => {
        let temp;
        if (props.selected.length == props.options.length) {
          temp = props.hasAll
        } else {
          if (props.selected.length) {
            temp = Object.values(props.selected).map((item) => {
              return item['text']
            });
          } else {
            //placeholder
            temp = props.placeholder['text']
          }
        }
        return temp
      }
    )

    // click the select box
    const onClick = () => {
      if(props.isDisable) return
      state.isOpen = !state.isOpen;
    }
    const handleFocusOut = () => {
      state.isOpen = false
    }







    return {
      state,
      onClick,
      onChange,
      handleFocusOut,
      classStyle,
      privateSelected,
      t,
      dataInit,
      selectAll,
      textLimit,
      checkStyle

    }
  }


}


